"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MATERIAL_TYPE = exports.MATERIAL_SIDE = exports.MATERIAL_SHADING = exports.MATERIAL_ALPHA = void 0;
// #endregion Interfaces (2)
// #region Enums (4)
var MATERIAL_ALPHA;
(function (MATERIAL_ALPHA) {
    MATERIAL_ALPHA["OPAQUE"] = "opaque";
    MATERIAL_ALPHA["MASK"] = "mask";
    MATERIAL_ALPHA["BLEND"] = "blend";
})(MATERIAL_ALPHA = exports.MATERIAL_ALPHA || (exports.MATERIAL_ALPHA = {}));
var MATERIAL_SHADING;
(function (MATERIAL_SHADING) {
    MATERIAL_SHADING["FLAT"] = "flat";
    MATERIAL_SHADING["SMOOTH"] = "smooth";
})(MATERIAL_SHADING = exports.MATERIAL_SHADING || (exports.MATERIAL_SHADING = {}));
var MATERIAL_SIDE;
(function (MATERIAL_SIDE) {
    MATERIAL_SIDE["DOUBLE"] = "double";
    MATERIAL_SIDE["FRONT"] = "front";
    MATERIAL_SIDE["BACK"] = "back";
})(MATERIAL_SIDE = exports.MATERIAL_SIDE || (exports.MATERIAL_SIDE = {}));
var MATERIAL_TYPE;
(function (MATERIAL_TYPE) {
    MATERIAL_TYPE["STANDARD"] = "Standard";
    MATERIAL_TYPE["SPECULAR_GLOSSINESS"] = "SpecularGlossiness";
    MATERIAL_TYPE["UNLIT"] = "Unlit";
    MATERIAL_TYPE["GEM"] = "Gem";
})(MATERIAL_TYPE = exports.MATERIAL_TYPE || (exports.MATERIAL_TYPE = {}));
// #endregion Enums (4)
//# sourceMappingURL=IMaterialAbstractData.js.map